<script>
import { mapGetters } from 'vuex'
import ExpansionPanels from '@/components/general/expansion-panels.vue'
import baseMixin from '@/mixins/baseMixin'
import CandidateShiftRecordJsonExtraData from '@/models/candidate/candidateShiftRecordJsonExtraData'

export default {
  components: { ExpansionPanels },
  mixins: [baseMixin],
  data: () => ({
    reasonsInfo: {
      durationIncreased: {
        title: 'Shift Duration Increased',
        icon: 'mdi-clock-plus-outline',
        color: 'primary',
      },
      mealReduced: {
        title: 'Meal Break Reduced',
        icon: 'mdi-food-off-outline',
        color: 'primary',
      },
      noRestBreaks: {
        title: 'Rest Break',
        icon: 'mdi-coffee-outline',
        color: 'primary',
      },
      didNotHappen: {
        title: 'Shift Did Not Happen',
        icon: 'mdi-cancel',
        color: 'error',
      },
    },
  }),

  computed: {
    ...mapGetters({ activeTimesheet: 'disputes/activeTimesheet' }),
    parsedCandidateReasons() {
      const jsonExtraData =
        this.activeTimesheet?.candidateTimesheet?.details?.jsonExtraData

      const parsedExtraData = this.parseJson(
        jsonExtraData,
        {},
        CandidateShiftRecordJsonExtraData
      )

      return Object.entries(parsedExtraData).map(([key, answer]) => {
        const {
          title = this.formatFieldKey(key),
          icon = 'mdi-alert-circle-outline',
          color = 'grey',
        } = this.reasonsInfo?.[key] || {}

        return { title, answer, key, icon, color }
      })
    },
  },
  methods: {
    formatFieldKey(value) {
      return value
        .replace(/([A-Z])/g, ' $1')
        .replace(/^./, (str) => str.toUpperCase())
    },
  },
}
</script>

<template>
  <v-card v-if="parsedCandidateReasons.length" class="mb-8" outlined>
    <v-card-text class="pa-0">
      <ExpansionPanels
        :items="parsedCandidateReasons"
        header-class="pa-0 pr-2"
        content-class="grey lighten-3"
        flat
        multiple
        expanded
      >
        <template v-slot:header-content="{ item }">
          <v-row align="center" class="pa-4">
            <v-col cols="auto" class="mr-4">
              <v-icon :color="item.color" size="24">{{ item.icon }}</v-icon>
            </v-col>
            <v-col>
              <span class="font-weight-medium">{{ item.title }}</span>
            </v-col>
          </v-row>
        </template>
        <template v-slot:panel-content="{ item }">
          <v-card-text class="text-body-1">{{ item.answer }}</v-card-text>
        </template>
      </ExpansionPanels>
    </v-card-text>
  </v-card>
</template>
